import React from "react";
import { useTranslation } from "../../../../localization/useTranslation";
import { useSystemDocumentDialog } from "./SystemDocumentDialog.hooks";
import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { SystemDocument } from "../SystemDocuments.types";
import DotLegalDocumentUploadWrapper from "../../../../common/components/DotLegalDocumentUploadWrapper";
import UploadProgressBar from "@common/components/uploadProgress/UploadProgressBar";

export interface SystemDocumentDialogProps {
    onDialogClose: () => void;
    onSave: () => void;
    selectedDocument?: SystemDocument;
}

function SystemDocumentDialog(props: SystemDocumentDialogProps) {
    const { translateString } = useTranslation();
    const {
        document,
        save,
        validation,
        isEdit,
        onNameChange,
        isLink,
        isSaving,
        documentUploadModel,
        setDocumentUploadModel,
        onDocumentUpload,
        isUploading,
        uploadPercentage,
    } = useSystemDocumentDialog(props);

    validation?.check(document);

    return (
        <DotLegalDialog
            size={"sm"}
            buttonOkText={isEdit ? translateString("save") : translateString("upload")}
            onDialogClose={props.onDialogClose}
            open
            onOkClick={() => save()}
            header={isEdit ? translateString("editDocument") : translateString("uploadDocument")}
            inProgress={isSaving}
            disableBackdropOnCloseIfValueChange={[document, documentUploadModel]}
        >
            <React.Fragment>
                <Grid size={{ md: 12 }}>
                    <DotLegalTextField
                        label={translateString("name")}
                        value={document?.name!}
                        debounce={false}
                        errorText={validation?.getErrorsForDisplay("name")}
                        onChange={(value) => {
                            onNameChange(value);
                        }}
                    />
                </Grid>
                <Box marginTop={2}>
                    {(!isEdit || (isEdit && isLink)) && (
                        <DotLegalDocumentUploadWrapper
                            showError={validation.showErrors}
                            viewModel={documentUploadModel}
                            onDataChange={(model) => {
                                onDocumentUpload(model.files);
                                setDocumentUploadModel(model);
                            }}
                            isEdit={isEdit}
                        />
                    )}
                </Box>
                <UploadProgressBar isUploading={isUploading} uploadPercentage={uploadPercentage} />
            </React.Fragment>
        </DotLegalDialog>
    );
}

export default SystemDocumentDialog;
